// extracted by mini-css-extract-plugin
export default {"diagram":"Diagram_diagram__dFAzB","sumExpensesIntoDiagram":"Diagram_sumExpensesIntoDiagram__z96NW"};